import { Stack } from 'src/design/atoms/Stack';
import React from 'react';
import { Header } from 'src/design/organisms/Header';
import { BackgroundJobsPanel } from 'src/routes/Settings/Healthcheck/components/BackgroundJobsPanel';
import { DatabaseStatusPanel } from 'src/routes/Settings/Healthcheck/components/DatabaseStatusPanel';
import { SendTestEmailPanel } from 'src/routes/Settings/Healthcheck/components/SendTestEmailPanel';
import { SyncDivisionsPanel } from 'src/routes/Settings/Healthcheck/components/SyncDivisionsPanel';

export const Healthcheck: React.FC = () => {
  return (
    <>
      <Header
        title="Healthcheck"
        breadcrumbProps={{
          items: [{ text: 'Settings' }, { text: 'Healthcheck' }],
        }}
        helpText="Healthcheck is a tool that checks the health of the databases and the application."
      />

      <Stack gap="md">
        <DatabaseStatusPanel />
        <BackgroundJobsPanel />
        <SendTestEmailPanel />
        <SyncDivisionsPanel />
      </Stack>
    </>
  );
};
